var _ = Symbol["for"]('_');

exports._ = _;

var __iterate = Symbol('__iterate');

exports.__iterate = __iterate;
var split = Symbol('split');
exports.split = split;